import { useSidePanel } from 'features/side-panels/hooks/useSidePanel';
import { usePolls } from 'features/polls/usePolls';
import { useAppSelector } from 'store/hooks';
import { selectUnreadPollUpdates } from 'features/side-panels/polls/pollsPanelSlice';

export const usePollsControl = () => {
  const { isPanelVisible, togglePanel } = useSidePanel();
  const unreadUpdates = useAppSelector(selectUnreadPollUpdates);

  const { isFeatureAvailable } = usePolls();

  const toggleChatPanel = () => {
    togglePanel('polls');
  };

  return {
    active: isPanelVisible('polls'),
    togglePanel: toggleChatPanel,
    icon: 'polls',
    isFeatureAvailable,
    unreadUpdates,
  };
};
